import React from 'react';
import styles from './loader.module.scss';

const DeleteIcon = (
  <svg width={18} height={18} viewBox="0 0 40 40" fill="currentColor">
    <rect x="28.7266" y="8.72949" width="3.5" height="28.2169" rx="1.76356" transform="rotate(45 28.7266 8.72949)" fill="currentColor"/>
    <rect x="8.77344" y="11.2236" width="3.5" height="28.2169" rx="1.76356" transform="rotate(-45 8.77344 11.2236)" fill="currentColor"/>
  </svg>
)

export const Badge = ({className = '', onDelete = null, style = {}, children }) => {
  const renderDeleteButton = () => {
    if (!onDelete) return null
    return (
      <button onClick={onDelete} style={{ marginLeft: 'auto', background: 'transparent', padding: 0, cursor: "pointer", height: 18, border: 'none', outline: 'none' }}>
        {DeleteIcon}
      </button>
    )
  }
  return (
    <div className={`${className.trim()} ${styles.badge}`} style={style}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {children}
        {renderDeleteButton()}
      </div>
    </div>
  );
}

export const BadgeTag = ({className = '', onDelete, style = {}, children }) => {
  const renderDeleteButton = () => {
    if (!onDelete) return null
    return (
      <button style={{ background: 'transparent', padding: 0, cursor: "pointer", height: 18, border: 'none', outline: 'none' }}>
        {DeleteIcon}
      </button>
    )
  }
  return (
    <div className={`${className.trim()} ${styles.badgeTag}`} style={style}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {children}
        {renderDeleteButton()}
      </div>
    </div>
  );
}
export const BadgeTagSmall = ({className = '', onDelete, style = {}, children }) => {
  const renderDeleteButton = () => {
    if (!onDelete) return null
    return (
      <button style={{ background: 'transparent', padding: 0, cursor: "pointer", height: 18, border: 'none', outline: 'none' }}>
        {DeleteIcon}
      </button>
    )
  }
  return (
    <div className={`${className.trim()} ${styles.badgeTagSmall}`} style={style}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {children}
        {renderDeleteButton()}
      </div>
    </div>
  );
}

